import React from 'react';

import { Suggestions } from '@mint-sdk/api-recommendations';

import useSuggestionTimeRange from '../../../hooks/useSuggestionTimeRange.js';
import type { SuggestionHeaderStatus } from '../../../types/chips.js';
import { StatusDetails } from './StatusDetails.jsx';

type Props = {
  suggestion: Suggestions.SuggestionResponseType;
  status: SuggestionHeaderStatus;
};

const SuggestionDateStatus = ({ suggestion, status }: Props) => {
  const { timeRangeArray } = useSuggestionTimeRange({
    status,
    decisionTime: suggestion.decisionTime,
    expiredAt: suggestion.expiredAt,
    reworkDate: suggestion.reworkDate,
  });

  const decidedBy = suggestion.decidedBy
    ? `${suggestion.decidedBy.firstName} ${suggestion.decidedBy.lastName}`
    : '';

  return (
    <StatusDetails
      decidedBy={decidedBy}
      status={status}
      timeRange={timeRangeArray}
    />
  );
};

export { SuggestionDateStatus };
